/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AlertsContentViewQueryEntrypointProps } from './AlertsContentViewQuery.entrypoint.types.tsx';
import parameters, {
	type AlertsContentViewQuery as AlertsContentViewQueryType,
} from './__generated__/AlertsContentViewQuery.graphql';
import type { PreloadParams } from './AlertsContentViewQuery.tsx';

type Queries = { queryRef: AlertsContentViewQueryType };

type AsyncAlertsContentViewQueryComponent = EntryPointComponent<
	Queries,
	{},
	AlertsContentViewQueryEntrypointProps,
	{}
>;

export const asyncAlertsContentViewQuery: EntryPoint<
	AsyncAlertsContentViewQueryComponent,
	PreloadParams
> = createEntryPoint({
	root: JSResourceForInteraction<AsyncAlertsContentViewQueryComponent>(
		/* webpackChunkName: "async-nav4-alerts-content-view-query" */ './AlertsContentViewQuery.tsx',
	),
	getPreloadProps: ({ cloudId }: PreloadParams) => ({
		queries: {
			queryRef: {
				parameters,
				variables: {
					cloudId,
				},
			},
		},
	}),
});
